import { ActionKeys } from '~/actions/constants';
import * as shippingMethodActions from '~/actions/shipping-methods.actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as shippingMethodServices from '~/services/shipping-methods.service';

export function* getShippingMethods() {
  try {
    const response = yield call(shippingMethodServices.fetchShippingMethods);
    const shippingMethods = response.data.results.shipping_methods;
    yield put(shippingMethodActions.fetchShippingMethodsSuccess(shippingMethods));
  } catch (err) {
    yield put(shippingMethodActions.fetchShippingMethodsError());
  }
}

export default [takeLatest(ActionKeys.FETCH_SHIPPING_METHODS, getShippingMethods)];
